<!-- <rap-breadcrumb-view-new [routerLink]="'/dashboard/explore'" [clickableLabel]="'Rap Almanac'"
    [clickableIcon]="'../assets/images/filled.svg'" [title]="title" [nonClickableLabel]="'Albums'"
    [nonClickableIcon]="'../assets/images/filled.svg'">
</rap-breadcrumb-view-new> -->

<div class="label-container">
    <div>
        <label class="clickable-label" routerLink="/dashboard/explore"> Rap Almanac </label>
        <img src="../assets/images/filled.svg" />
    </div>

    <div>
        <label class="non-clickable-label">{{title}}</label>
        <img src="../assets/images/filled.svg" />
    </div>
    <div>
        <label class="non-clickable-label" style="text-decoration: none;">Albums</label>
    </div>

</div>


<div class="section-body">
    <div class="section-title">Albums</div>
    <!-- <button type="button" class="btn btn-dark add-song-btn" (click)="createAlbum()" style="margin-bottom: 20px;">
        Add New
    </button> -->
    <rap-rect-primary [label]="'Add New'" [btnClass]="'btn btn-dark'" (clickEvent)="createAlbum()"></rap-rect-primary>
    <rap-spinner class="loader-overlay" *ngIf="isLoading"></rap-spinner>

</div>

<rap-search-input [(searchValue)]="filters.search" (search)="getSearchResults($event)"
    (clear)="onClearSearch()"></rap-search-input>
<div style="padding: 0px 10px;">
    <ng-container *ngIf="albumsData?.length > 0">
        <div class="custom-container">
            <div class="songs-table" *ngIf="albumsData?.length > 0">
                <table class="table rounded-4 overflow-hidden">
                    <thead>
                        <tr>

                            <th scope="col">
                                <div class="sortable">
                                    <div (click)="onSort({ column: 'album', direction: sortDirection })">TITLE</div>
                                    <rap-sort-arrows [column]="'album'" [sortedColumn]="sortedColumn"
                                        [sortDirection]="sortDirection" (sort)="sortBy($event)">
                                    </rap-sort-arrows>
                                </div>
                            </th>

                            <th scope="col">
                                <div class="sortable">
                                    <div (click)="onSort({ column: 'artist', direction: sortDirection })">ARTIST
                                    </div>
                                    <rap-sort-arrows [column]="'artist'" [sortedColumn]="sortedColumn"
                                        [sortDirection]="sortDirection" (sort)="sortBy($event)">
                                    </rap-sort-arrows>
                                </div>
                            </th>

                            <th scope="col">
                                <div class="sortable">
                                    <div (click)="onSort({ column: 'release_date', direction: sortDirection })">RELEASE
                                        DATE
                                    </div>
                                    <rap-sort-arrows [column]="'release_date'" [sortedColumn]="sortedColumn"
                                        [sortDirection]="sortDirection" (sort)="sortBy($event)">
                                    </rap-sort-arrows>
                                </div>
                            </th>
                            <th scope="col">ACTIONS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let album of paginatedAlbums">
                            <td scope="row">{{ album?.album }}</td>
                            <td scope="row">
                                {{ album?.artist?.artist }}
                            </td>

                            <td scope="row">{{ album?.release_date }}</td>
                            <td>
                                <button type="button" class="btn btn-light rect-secondary-btn"
                                    (click)="editAlbum(album)">
                                    Edit
                                </button>
                                <button type="button" class="btn btn-dark rect-primary-btn"
                                    (click)="deleteAlbum(album.albumid)">
                                    Delete
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="pagination">
                    <rap-pagination [collectionSize]="pagesCount" [page]="page" [pageSize]="pageSize"
                        (onPageChange)="onPageChange($event)"
                        (onPageSizeChange)="onPageSizeChange($event)"></rap-pagination>
                </div>
            </div>
        </div>

    </ng-container>
</div>


<rap-no-data [data]="albumsData" [isLoading]="isLoading" [filters]="filters" [message]="'No albums found'"
    [view]=""></rap-no-data>